var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-notice-bar',{attrs:{"color":"rgb(57, 118, 198)","background":"#f5f7f9","left-icon":"weapp-nav","scrollable":false}},[_vm._v(" 共 "+_vm._s(_vm.total)+" 条 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }